var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13c0-1.886 0-2.828.586-3.414C5.672 9 6.614 9 8.5 9h8c1.886 0 2.828 0 3.414.586.586.586.586 1.528.586 3.414v2c0 2.828 0 4.243-.879 5.121C18.743 21 17.328 21 14.5 21h-4c-2.828 0-4.243 0-5.121-.879C4.5 19.243 4.5 17.828 4.5 15v-2Z",
    stroke: "#4D5054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17 9 .078-.62a5.519 5.519 0 0 0-2.41-5.273v0a5.519 5.519 0 0 0-6.68.416l-.818.708",
    stroke: "#4D5054",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 15,
    r: 2,
    fill: "#4D5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.11df73dd5b94743418da9d0e2aa40702.svg";
export { ForwardRef as ReactComponent };